<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="140px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userName" label="客户名称">
              {{ formData.userName || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="depositNumber" label="流水凭证单号">
              {{ formData.depositNumber || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="approvalStatus" label="审批状态">
              <el-tag v-if="formData.approvalStatus == '1'">待审批</el-tag>
              <el-tag type="success" v-if="formData.approvalStatus == '2'">审批通过</el-tag>
              <el-tag type="danger" v-if="formData.approvalStatus == '3'">审批驳回</el-tag>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="depositType" label="保证金类型">
              <!-- {{ formData.depositType == '1' ? '充值' : formData.depositType == '2' ? '退还' : '' }} -->
              {{ depositTypeMap.get(formData.depositType) }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="depositChange" label="充值/退还金额(元)">
              {{ formData.depositChange || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || "" }}
            </el-form-item>
          </el-col>

        </el-row>
        <el-row v-if="formData.fileList && formData.fileList.length > 0">
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="审批记录">
              <el-timeline :reverse="true" placement="top">
                <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index"
                  :timestamp="item.approvalTime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24">
                        审批状态：
                        <el-tag v-if="item.approvalStatus == '1'">待审批</el-tag>
                        <el-tag type="success" v-if="item.approvalStatus == '2'">审批通过</el-tag>
                        <el-tag type="danger" v-if="item.approvalStatus == '3'">审批驳回</el-tag>
                      </el-col>
                      <el-col :span="24">
                        审批名称：{{ item.approvalName || '--' }} </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        审批意见：{{ item.approvalComments || '--' }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">审批人:{{ item.approver || '--' }}</el-col>
                      <el-col :span="12">审批时间：:{{ item.submitTime || '--' }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">提交人:{{ item.submitter || '--' }}</el-col>
                      <el-col :span="12">提交时间:{{ item.submitTime || '--' }}</el-col>
                    </el-row>
                    <el-row v-if="item.fileList && item.fileList.length > 0">
                      <el-col :span="24">
                        附件：
                        <file-upload readonly v-model="item.fileList"></file-upload>
                      </el-col>
                    </el-row>
                  </el-card>

                </el-timeline-item>
              </el-timeline>
              <!-- <el-table size="mini" stripe border :data="formData.recordList">
                <el-table-column min-width="120" label="提交人" prop="submitter"></el-table-column>
                <el-table-column min-width="120" label="审批人" prop="approver"></el-table-column>
                <el-table-column min-width="120" label="审批状态" prop="changeReason">
                  <template v-slot="{ row }">
                    <el-tag v-if="row.approvalStatus == '1'">待审批</el-tag>
                    <el-tag type="success" v-if="row.approvalStatus == '2'">审批通过</el-tag>
                    <el-tag type="info" v-if="row.approvalStatus == '3'">审批驳回</el-tag>

                  </template>
</el-table-column>
<el-table-column min-width="120" label="提交时间" prop="submitTime"></el-table-column>
<el-table-column min-width="120" label="审批时间" prop="approvalTime"></el-table-column>
<el-table-column min-width="120" label="审批意见" prop="approvalComments"></el-table-column>
<el-table-column width="120" label="操作" fixed="right">
  <template v-slot="{ row }">

                    <el-button type="text" @click="onDetail(row)">详情</el-button>

                  </template>
</el-table-column>
</el-table> -->

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <!--
    <ApprovalDetail v-if="showDetail" @closeDlg="showDetail = false" :showDlg.sync="showDetail" :rowData="rowData">
    </ApprovalDetail> -->

  </div>
</template>

<script>
import { depositType } from '@/utils/dict'
export default {
  name: 'userBond',
  data() {
    return {
      depositTypeMap: depositType,
      formData: {
        depositId: '',
        depositNumber: '',
        userId: '',
        approvalStatus: '',
        depositType: '',
        depositChange: '',
        createUserId: '',
        ctime: '',
        fileList: [],
        recordList: []
      },

      loading: false,
      showDetail: false,
      rowData: {}
    }
  },
  created() {
    if (this.depositId) {
      this.loadData()
    }
  },
  computed: {
    depositId() {
      return this.$route.query.depositId
    }
  },
  methods: {
    onDetail(row) {
      this.rowData = row
      this.showDetail = true
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.bondRecord.selectYxUserDepositRecordByDepositId, {
          params: { depositId: this.depositId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          res.recordList = res.recordList ? res.recordList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
